module.exports = __webpack_public_path__ + "static/media/2014-normalized.fc03209c.csv";